<template>
  <div class="absolute w-full h-full pointer-events-none">
    <svg xmlns="http://www.w3.org/2000/svg" width="91" height="70" viewBox="0 0 91 70" fill="none"
    class="absolute top-0 left-0">
      <g opacity="0.2">
        <path d="M90 0V20C90 26.6274 84.6274 32 78 32H63C56.3726 32 51 37.3726 51 44V55.5C51 62.1274 45.6274 67.5 39 67.5H0" stroke="white"/>
        <path d="M0 26.5H17.5C24.1274 26.5 29.5 31.8726 29.5 38.5V43C29.5 49.6274 34.8726 55 41.5 55H78" stroke="white"/>
        <circle cx="20" cy="67.5" r="1.5" fill="white" stroke="white"/>
        <circle cx="68" cy="32" r="1.5" fill="white" stroke="white"/>
        <circle cx="78" cy="55" r="1.5" fill="white" stroke="white"/>
        <circle cx="24" cy="28.5" r="1.5" fill="white" stroke="white"/>
      </g>
    </svg>
    <svg xmlns="http://www.w3.org/2000/svg" width="92" height="73" viewBox="0 0 92 73" fill="none"
    class="absolute -top-0.5 right-0">
      <g opacity="0.2">
        <path d="M2 0V36C2 42.6274 7.37258 48 14 48H55.25C60.6348 48 65 52.3652 65 57.75V57.75C65 63.1348 69.3652 67.5 74.75 67.5H92" stroke="white"/>
        <path d="M92 26.5H62.5H51C44.3726 26.5 39 31.8726 39 38.5V59C39 65.6274 33.6274 71 27 71H14" stroke="white"/>
        <circle cx="2" cy="2" r="1.5" transform="matrix(-1 0 0 1 74 65.5)" fill="white" stroke="white"/>
        <circle cx="2" cy="2" r="1.5" transform="matrix(-1 0 0 1 4 25)" fill="white" stroke="white"/>
        <circle cx="2" cy="2" r="1.5" transform="matrix(-1 0 0 1 16 69)" fill="white" stroke="white"/>
        <circle cx="2" cy="2" r="1.5" transform="matrix(-1 0 0 1 66 24.5)" fill="white" stroke="white"/>
      </g>
    </svg>
    <svg xmlns="http://www.w3.org/2000/svg" width="91" height="70" viewBox="0 0 91 70" fill="none"
    class="absolute bottom-0 left-0">
      <g opacity="0.2">
        <path d="M90 69.5V57.5C90 50.8726 84.6274 45.5 78 45.5H36.75C31.3652 45.5 27 41.1348 27 35.75V35.75C27 30.3652 22.6348 26 17.25 26H0" stroke="white"/>
        <path d="M0 59.5H29.5H41C47.6274 59.5 53 54.1274 53 47.5V27C53 20.3726 58.3726 15 65 15H78" stroke="white"/>
        <circle cx="2" cy="2" r="1.5" transform="matrix(1 0 0 -1 16 61)" fill="white" stroke="white"/>
        <circle cx="2" cy="2" r="1.5" transform="matrix(1 0 0 -1 72 47.5)" fill="white" stroke="white"/>
        <circle cx="2" cy="2" r="1.5" transform="matrix(1 0 0 -1 76 16.5)" fill="white" stroke="white"/>
        <circle cx="2" cy="2" r="1.5" transform="matrix(1 0 0 -1 27.5 44)" fill="white" stroke="white"/>
      </g>
    </svg>
    <svg xmlns="http://www.w3.org/2000/svg" width="91" height="70" viewBox="0 0 91 70" fill="none"
    class="absolute -bottom-1.5 right-0">
      <g opacity="0.2">
        <path d="M1 69.5V49.5C1 42.8726 6.37258 37.5 13 37.5H28C34.6274 37.5 40 32.1274 40 25.5V14C40 7.37258 45.3726 2 52 2H91" stroke="white"/>
        <path d="M91 43H73.5C66.8726 43 61.5 37.6274 61.5 31V26.5C61.5 19.8726 56.1274 14.5 49.5 14.5H13" stroke="white"/>
        <circle cx="71" cy="2" r="1.5" transform="rotate(180 71 2)" fill="white" stroke="white"/>
        <circle cx="23" cy="37.5" r="1.5" transform="rotate(180 23 37.5)" fill="white" stroke="white"/>
        <circle cx="13" cy="14.5" r="1.5" transform="rotate(180 13 14.5)" fill="white" stroke="white"/>
        <circle cx="67" cy="41" r="1.5" transform="rotate(180 67 41)" fill="white" stroke="white"/>
      </g>
    </svg>
  </div>
</template>

<script>
export default {
  name: 'KeyCardDecoration'
}
</script>

<style scoped></style>